import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=a1d7788a"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1d7788a')) {
      api.createRecord('a1d7788a', component.options)
    } else {
      api.reload('a1d7788a', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=a1d7788a", function () {
      api.rerender('a1d7788a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/functionality/Form.vue"
export default component.exports